
import React from "react";
import styles from './Footer.module.css';
import {FaEnvelope, FaMapMarkerAlt, FaPhoneAlt} from "react-icons/fa";
import {GoDotFill} from "react-icons/go";

function Footer(props) {

    return (
        <React.Fragment>
            <iframe width="" height="400"
                    src="https://maps.google.de/maps?hl=de&q=IKS%20%20Kaiserkronenweg+1,+60433+Frankfurt+am+Main&t=&z=14&ie=utf8&iwloc=b&output=embed"
                    frameBorder="0" scrolling="no" marginHeight="0" marginWidth="0"
                    style={{height: '400px', width: '100%', marginBottom: -5}}></iframe>


            {/* <Contact/> */}

            <div>
                <div className="grid">

                    <div
                        className="lg:col-2"
                        style={{
                            background: '#154778',
                            color: '#FFFFFF',
                            border: '1px solid #5581b0'}}/>
                    <div className="lg:col-4 col-12"
                         style={{
                             background: '#154778',
                             color: '#FFFFFF',
                             border: '1px solid #5581b0'}}>
                        <div style={{paddingBottom: 20, fontWeight: 600, fontSize: 24}}>IKS - Interkulturelle Schule
                            Rhein-Main
                        </div>
                        Die IKS - Interkulturelle Schule Rhein-Main hat eine beeindruckende 70-jährige Geschichte des
                        Wandels und Fortschritts durchlaufen. Sie begann als Handelsschule Hierse, entwickelte sich
                        unter der Leitung von Herrn Günter Koch weiter und fusionierte schließlich mit der European
                        School of Economics zur IKS, die heute eine Grundschule und eine Integrierte Gesamtschule
                        umfasst und sich für Bildung und Integration engagiert (mehr).
                    </div>
                    <div className={"lg:col-2 col-6 " + styles.listBlock}
                         style={{
                             background: '#045184',
                             color: '#FFFFFF',
                             border: '1px solid #5581b0',
                             fontSize: 14}}>
                        <div onClick={() => window.location.href = '/impressum'} style={{cursor: 'pointer'}}><GoDotFill style={{paddingTop: 20}}/> Impressum</div>
                        <div onClick={() => window.location.href = '/datenschutz'} style={{cursor: 'pointer'}}><GoDotFill style={{paddingTop: 30}}/> Datenschutz</div>
                        <div onClick={() => window.location.href= '/karriere'} style={{ cursor: 'pointer'}}><GoDotFill style={{paddingTop: 30}}/> Karriere</div>
                    </div>
                    <div className="lg:col-2 col-6"
                         style={{
                             background: '#1e66ac',
                             color: '#FFFFFF',
                             border: '1px solid #5581b0'}}>
                        <div className="grid">
                            <div className="col-fixed" style={{width: '30px'}}>
                                <FaMapMarkerAlt/>
                            </div>
                            <div className="col" style={{marginTop: '4px'}}>
                                IKS Interkulturelle Schule Rhein-Main<br />
                                Kaiserkronenweg 1<br />
                                60433 Frankfurt am Main
                            </div>
                        </div>
                        <div style={{height: 5}}/>
                        <div className="grid">
                            <div className="col-fixed" style={{width: '30px'}}>
                                <FaPhoneAlt/>
                            </div>
                            <div className="col" style={{marginTop: '5px'}}>
                                <a href="tel:+496927997180" style={{textDecoration: 'none', color: '#FFFFFF'}}> 069 279 971 80</a>
                            </div>
                        </div>
                        <div className="grid">
                            <div className="col-fixed" style={{width: '30px'}}>
                                <FaEnvelope/>
                            </div>
                            <div className="col" style={{marginTop: '5px'}}>
                                <a href="mailto:info@iks-schule.de" style={{textDecoration: 'none', color: '#FFFFFF'}}>info@iks-schule.de</a>
                            </div>
                        </div>
                    </div>

                    <div className="lg:col-2" style={{
                        background: '#1e66ac',
                        color: '#FFFFFF',
                        border: '1px solid #5581b0'}}/>
                    <div className="col-12" style={{
                        background: '#154778',
                        color: '#FFFFFF',
                        border: '1px solid #5581b0',
                        textAlign: 'center'
                    }}>
                        ©2023 von IKS Interkulturelle Schule Rhein-Main - All Rights Reserved
                    </div>
                </div>
            </div>
        </React.Fragment>
    );
}

export default Footer;